import { isPlainObject } from 'es-toolkit/predicate';

/**
 * Type guard for a plain object — narrows to `Record<string, unknown>` and rejects
 * arrays, `null`, primitives, and non-plain objects (class instances, `Date`, `Map`).
 * Wraps es-toolkit's `isPlainObject`, whose own return type is `Record<PropertyKey, any>`.
 * @param value - The value to test.
 * @returns `true` if `value` is a plain object.
 * @example
 * isPlainRecord({ a: 1 })   // true
 * isPlainRecord([])         // false
 * isPlainRecord(new Date()) // false
 */
export const isPlainRecord = (value: unknown): value is Record<string, unknown> => isPlainObject(value);
